import api from './api';
import { ApiResponse } from '@invoiceflow/shared';
import { getRefreshToken } from '../stores/useAuthStore';

interface AuthUser {
  id: string;
  name: string;
  email: string;
  tenantId: string;
  role: 'superadmin' | 'admin';
  isActive: boolean;
}

interface AuthResponse {
  user: AuthUser;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
}

export const AuthService = {
  login: async (credentials: Record<string, string>) => {
    const response = await api.post<ApiResponse<AuthResponse>>('/auth/login', credentials);
    return response.data;
  },

  register: async (data: Record<string, string | number | boolean>) => {
    const response = await api.post<ApiResponse<AuthResponse>>('/auth/register', data);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get<ApiResponse<{ user: AuthUser }>>('/auth/me');
    return response.data;
  },

  requestPasswordReset: async (email: string) => {
    const response = await api.post<ApiResponse<void> & { message?: string }>(
      '/auth/password-reset/request',
      { email }
    );
    return response.data;
  },

  resetPassword: async (token: string, password: string) => {
    const response = await api.post<ApiResponse<void> & { message?: string }>(
      '/auth/password-reset/reset',
      { token, password }
    );
    return response.data;
  },

  logout: async () => {
    // Send the refresh token so the server can revoke it too.
    const refreshToken = getRefreshToken();
    const response = await api.post<ApiResponse<void>>('/auth/logout', { refreshToken });
    return response.data;
  },
};
